module.exports = __webpack_public_path__ + "static/media/om.b8f843cc.svg";